import { useMutation } from "@tanstack/react-query";
import { BookingService } from "@/services/BookingService";
import type { Booking } from "@/types/Booking";

type UpdateBookingRoomParams = {
  bookingId: string;
  newRoomId: string;
};

/**
 * Hook to update a booking's room
 * Uses React Query's useMutation for proper loading/error states and automatic cache invalidation
 */
export function useUpdateBookingRoom() {
  const bookingService = new BookingService();

  return useMutation<Booking, Error, UpdateBookingRoomParams>({
    mutationFn: async (params: UpdateBookingRoomParams) => {
      return await bookingService.updateBookingRoom(params.bookingId, params.newRoomId);
    },
  });
}
